var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isListingPage && (!_vm.ready || _vm.pageLoading))?_c('div',{staticClass:"app-preloader"},[_c('Preloader')],1):_vm._e(),(_vm.ready || (_vm.isListingPage && _vm.routerReady))?_c('div',{},[(!['checkup'].includes(_vm.$route.name))?_c('NavBar'):_vm._e(),_c('router-view'),(
          [
            'home',
            'faq',
            'login',
            'ad',
            'my-account',
            'matches',
            'create-ad',
            'about-us',
            'jobs',
            'terms',
            'history',
            'lagenhetsbyte',
            'cookies' ].includes(_vm.$route.name)
        )?_c('Footer'):_vm._e()],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }